import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { taskStatuses } from "utils/static/workflowsStaticData";
import { Button } from "@material-ui/core";
import WarningIcon from "@material-ui/icons/Warning";
import TimerTwoToneIcon from "@material-ui/icons/TimerTwoTone";

const statusStyles = (theme) =>
    taskStatuses.reduce((map, item) => {
        const style = Object.keys(item.style).reduce((obj, attr) => ({ ...obj, [attr]: `${item.style[attr]} !important` }), {});
        return {
            ...map,
            [item.value]: {
                margin: theme.spacing(4, 0, 0, 0),
                ...style,
            },
            [`${item.value}_cell`]: {
                margin: theme.spacing(0.5, 0.5, 0.5, 0.5),
                paddingTop: 0,
                paddingBottom: 0,
                ...style,
            },
        };
    }, {});

export const useWorkflowStyles = makeStyles((theme) => ({
    finishedButton: {
        margin: theme.spacing(4, 0, 0, 0),
        backgroundColor: "green !important",
        color: "white !important",
    },
    notFinishedButton: {
        margin: theme.spacing(4, 0, 0, 0),
        backgroundColor: "#dcdcdc !important",
        color: "#808080 !important",
    },
    ...statusStyles(theme),
    dueDateCell: {
        display: "flex",
        justifyContent: "flex-start",
    },
    alertIcon_aboutToExpire: {
        color: "#ffcc00",
        width: 16,
        height: 16,
        marginLeft: 10,
    },
    alertIcon_expired: {
        color: "#ff3333",
        width: 16,
        height: 16,
        marginLeft: 10,
    },
    orderCell: {
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
    },
    waitingForPreviousTask: {
        color: "#3f51b5",
        width: 20,
        height: 20,
        marginLeft: 10,
    },
}));

export const getHeadCells = (workflowClasses) => [
    {
        index: 1,
        id: "ordinal",
        disablePadding: false,
        label: "Order",
        render: (_, { value, data }) => {
            return (
                <div className={workflowClasses.orderCell}>
                    {value}
                    {data.waitForPreviousTask && data.previousTaskId && !data.finished && (
                        <div title="Waiting for the previous task to be closed!">
                            <TimerTwoToneIcon className={workflowClasses.waitingForPreviousTask} />
                        </div>
                    )}
                </div>
            );
        },
    },
    { index: 2, id: "assigneeUserFullName", disablePadding: false, label: "Assignee" },
    { index: 3, id: "name", disablePadding: false, label: "Name" },
    {
        index: 4,
        id: "statusString",
        disablePadding: false,
        label: "Status",
        render: (_, { value, data }) => {
            return (
                <Button
                    variant="contained"
                    size="small"
                    disabled
                    startIcon={taskStatuses.find((x) => x.value === data.status).icon}
                    className={workflowClasses[`${data.status}_cell`]}
                >
                    {value}
                </Button>
            );
        },
    },
    {
        index: 5,
        id: "dueDateString",
        disablePadding: false,
        label: "Due Date",
        render: (_, { value, data }) => {
            return (
                <div className={workflowClasses.dueDateCell}>
                    {value}
                    {data.dueAlert && !data.finished && (
                        <div title={data.dueAlert.message}>
                            <WarningIcon className={workflowClasses[`alertIcon_${data.dueAlert.dueStatus}`]} />
                        </div>
                    )}
                </div>
            );
        },
    },
    { index: 6, id: "startDateString", disablePadding: false, label: "Start Date" },
    { index: 7, id: "endDateString", disablePadding: false, label: "End Date" },
];
